import React, { Component } from "react";

export default class TMaskText extends Component {
  componentWillReceiveProps(props) {}

  render() {
    const field = this.props.field;
    const i = this.props.id;
    return (
      <div className="form-group">
        <label>
          <b>{field.label}</b> <span id={"rule" + field.name}></span>
        </label>
        <input
          type="text"
          className="form-control"
          id={this.props.id}
          key={i}
          name={this.props.name}
          placeholder={
            "id: " +
            field.name +
            (field.length === null || field.length === undefined
              ? " - (Vacío)"
              : field.length === undefined)
          }
          disabled="disabled"
        />
      </div>
    );
  }
}
